import Vue2Leaflet from 'vue2-leaflet'
import "leaflet/dist/leaflet.css"
import { MAP_URL, SAT_MAP_URL } from '../../config.js'

export default {
    components: {            
        'l-map': Vue2Leaflet.LMap,
        'l-polygon': Vue2Leaflet.LPolygon,
        'l-circle' : Vue2Leaflet.LCircle,
        'l-tilelayer': Vue2Leaflet.LTileLayer,
        'l-marker': Vue2Leaflet.LMarker,
        'l-group': Vue2Leaflet.LLayerGroup,
        'l-popup': Vue2Leaflet.LPopup,
        'l-tooltip-content': Vue2Leaflet.LTooltipContent,
        'l-polyline': Vue2Leaflet.LPolyline,
        'l-tooltip': Vue2Leaflet.LTooltip,
        'l-control-zoom': Vue2Leaflet.LControlZoom,
    },
    data(){
        return {
            zoom: 10,
            url: MAP_URL,//'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            markers:[{id:10001, position:{lat: 52, lon: 6.1}},{id:20001, position: { lat: 52.2, lon: 6.2} }],
            bounds: null,
            mapCenter: [52.5,6],            
            mapOptions: {zoomControl: false},
            mapType: 'default'
        }
    },
    methods:{
        useSatMap(){
            this.url = SAT_MAP_URL
            this.mapType = 'satellite'
        },
        centerGeozone(geozone){            
            let boundsArr = []
            for(let coords of geozone.geopoly.coordinates[0]){                
                boundsArr.push([coords[1], coords[0]]);
            }            
            this.bounds = boundsArr            
        },
        useDefaultMap(){
            this.url = MAP_URL
            this.mapType = 'default'
        },
        genericLocationIcon(opt = []){
            let color = (opt.color) ? opt.color : '#3e5871';
            let icon = (opt.icon) ? opt.icon : ''
            let html = `<div class="marker-pin">
                            <div
                            class="inner-pin "
                            style="background-color:${color}">
                            <i class="${icon}"></i></div>  
                        </div>`;
            return L.divIcon({
                iconSize: new L.Point(34, 34),
                iconAnchor: [17, 34],
                someData: "test",
                html
            });
        },
        center(lat, lon){            
            this.mapCenter = [lat, lon]            
            return this.mapCenter

          },
          marker(lat, lon){
            if(lat && lon){
                return L.latLng(lat, lon)
            }
            else{
              return null
            }
        },
        locationIcon(color, icon){
            //let color = '#e91e63'
            let html = `<div class="marker-pin">
                            <div
                                class="inner-pin "
                                style="background-color:${color}">
                                <i class="${icon}"></i>
                            </div>      
                        </div>`      
            return L.divIcon({
                iconSize: new L.Point(34, 34),
                iconAnchor:[17,34],                
                html
            });
          },          
          geojsonCoordinatesToPoly(coords){
            let ret = []
            
            for(let i = 0; i < coords[0].length; i++){
                ret.push([coords[0][i][1], coords[0][i][0]])
            }
            
            return [ret]            
          },
          geojsonLineDistanceHumanReadable(ld){
            if(ld > 1000){
                return `${(ld / 1000).toFixed(1)} km`
            }
            else{
                return `${(ld)} meter`
            }
        },
        geoJsonSquareMeasureHumanReadable(sm){
            if(sm < 100000){
                return `${sm} m2`
            }
            else{
                return `${(sm / 1000 / 1000).toFixed(1)} km2`
            }
        },
        generateIcon(asset, options){
            
            let shape = (options.shape) ? options.shape : 'square'
            let color = (options.color) ? options.color : '#fff'
            let icon = (options.icon) ? options.icon : null
            let size = (options.size) ? options.size : 20
            let selected = (options.selected) ? options.selected : false
            let showIdentifier = (options.showIdentifier) ? options.showIdentifier : false
            let showPrimaryData = (options.showPrimaryData) ? options.showPrimaryData : false

            switch(shape){
                case 'square' : 
                    return this._createSquareIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData)

                case 'circle' : 
                    return this._createCircleIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData)
                    
                case 'triangle': 
                    return this._createTriangleIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData)
                
                case 'diamond-shield': 
                    return this._createDiamondShieldIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData)
                
                default :
                    return this._createSquareIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData)
            }
        },

        generateShapeStyle(shape, size){
            switch(shape){
                case 'circle': 
                    return this._createCircleIconStyle(size)
                case 'triangle': 
                    return this._createCircleIconStyle(size)
                default :
                    return this._createSquareIconStyle(size)
            }
        },
        getCentroid(polygon){
 
            var twoTimesSignedArea = 0;
            var cxTimes6SignedArea = 0;
            var cyTimes6SignedArea = 0;
        
            var length = polygon.length
        
            var x = function (i) { return polygon[i % length][0] };
            var y = function (i) { return polygon[i % length][1] };
        
            for ( var i = 0; i < polygon.length; i++) {
                var twoSA = x(i)*y(i+1) - x(i+1)*y(i);
                twoTimesSignedArea += twoSA;
                cxTimes6SignedArea += (x(i) + x(i+1)) * twoSA;
                cyTimes6SignedArea += (y(i) + y(i+1)) * twoSA;
            }
            var sixSignedArea = 3 * twoTimesSignedArea;
            return [ cxTimes6SignedArea / sixSignedArea, cyTimes6SignedArea / sixSignedArea]; 
        },
        _createCircleIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData){
            let selectedClass = (selected) ? this._getSelectedMarkerClass() : ''
            
            return `<div 
                        class="simple-marker-pin ${selectedClass}" 
                        style="background-color: ${color}; width: ${size}px;  height: ${size}px; border-radius:50%;" 
                    >${this._getFaIcon(icon,size)}</div>`            
        },
        _createSquareIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData){
            let selectedClass = (selected) ? this._getSelectedMarkerClass() : ''
            let dataBadge = '';
            if(showIdentifier || showPrimaryData){
                dataBadge = this._createDataBadge(asset, showIdentifier, showPrimaryData);            
            }
            
            return `<div style="display:flex;">
                        <div 
                            class="simple-marker-pin ${selectedClass}" 
                            style="background-color: ${color}; width: ${size}px;  height: ${size}px; border-radius:5px; display:flex;" 
                        >${this._getFaIcon(icon,size)}</div><div >${dataBadge}</div></div>`            
        },
        _createTriangleIconStyle(asset, shape, color, size, icon, selected, showIdentifier, showPrimaryData){
            let selectedClass = (selected) ? this._getSelectedMarkerClass() : ''
            return `<div style="position:absolute; display: flex; align-items:center; align-content:center; justify-content: center;" >
                                    
                        <div 
                        class="simple-marker-pin ${selectedClass} no-shadow" 
                        style="                        
                            position:absolute;
                            background: none;
                            border-radius: 4px;
                            border-top: none;
                            width: 0px;  height: 0px; 
                            
                            border-left: ${(size / 1.5) + 6}px solid transparent;
                            border-right: ${(size / 1.5) + 6}px solid transparent;
                            border-bottom: ${size + 12}px solid ${color};
                            opacity: 0.5;" 
                        ></div>            
                        <div 
                        class="simple-marker-pin ${selectedClass} no-shadow" 
                        style="
                            margin-top: 2px;
                            border-radius: 4px;
                            position:absolute;
                            background: none;                            
                            border-top: none;
                            width: 0px;  height: 0px; 
                            border-left: ${size / 1.5}px solid transparent;
                            border-right: ${size / 1.5}px solid transparent;
                            border-bottom: ${size}px solid ${color};" 
                        ></div>
                    </div>`
        },
        
        _getSelectedMarkerClass() {
            return "selected-asset-marker animated infinite heartBeat "                            
        },
        _getFaIcon(icon, size){
            let iconHtml = ''
            if(icon && size > 20){
                if(size < 30){
                iconHtml = `<i class="${icon}" style="font-size: ${size - 14}px;"></i>`  
                }
                else{
                iconHtml = `<i class="${icon}" style="font-size: ${size - 20}px;"></i>`
                }        
            }
            return iconHtml
        },
        _createDataBadge(asset, showIdentifier, showPrimaryData){
            
            let assetName = asset.name
            let width = 120;
            if(!showIdentifier){
                assetName = '';
                width = 44;                

            }
            
            if(asset.customFields && showPrimaryData){
            
                let dataField = asset.customFields.find(ele => ele.primary)                
                
                if(dataField){
                    let val = dataField.value;
                    
                    if(dataField.dataType == 'numeric' || !dataField.dataType){
                        val = parseFloat(dataField.value).toFixed(dataField.decimals)
                    }
                    return `<div class="asset-data-badge" style="width: ${width}px">${assetName} ${(assetName.length > 0) ? '<br>' : ''} ${val} ${(dataField.typeShort) ? dataField.typeShort : ''}</div>`
                }                
                return `<div class="asset-data-badge" style="width: ${width}px">${assetName}</div>`
            }
            else{
                return `<div class="asset-data-badge" style="width: ${width}px">${assetName}</div>`
            }
            
        },
        _createNameBadge(asset){                        
            return `<div class="asset-name-badge">${asset.name}</div>`                                
        }


    }
}
